define('services/appmng/operanteSha.service',['app'], function (app) {
    return app.factory('opearteShaService', ['OpenGW','$timeout',
        function (OpenGW,$timeout) {

        function opearteShaService(attrs,scope) {
            delete attrs.oauthCertFingerprint;
            delete attrs.certFingerprintExtra;
            var certFingerprintExtraTemp =[];
            if(!AUI.BaseJSUtil.existy(scope.oauthCertFingerprint)){
                for(var i =1;i<5;i++){
                    if((!attrs.oauthCertFingerprint || attrs.oauthCertFingerprint =="") && scope['oauthCertFingerprint'+i] &&scope['oauthCertFingerprint'+i] !=""){
                        attrs.oauthCertFingerprint = scope['oauthCertFingerprint'+i].replace(/:/g, "");
                    }else{
                        if(scope['oauthCertFingerprint'+i]  && scope['oauthCertFingerprint'+i] .replace(/:/g, "") !="") certFingerprintExtraTemp.push(scope['oauthCertFingerprint'+i] .replace(/:/g, ""));
                    }
                }
            }else{
                attrs.oauthCertFingerprint = scope.oauthCertFingerprint.replace(/:/g, "");
                for(var j=1;j<5;j++){
                    if(scope['oauthCertFingerprint'+j] && scope['oauthCertFingerprint'+j].replace(/:/g, "") !="") certFingerprintExtraTemp.push(scope['oauthCertFingerprint'+j].replace(/:/g, ""));
                }
            }
            if(certFingerprintExtraTemp.length>0){
                attrs.certFingerprintExtra = certFingerprintExtraTemp.join(";");
            }else{
                attrs.certFingerprintExtra = "";
            }
        }

        // 发送消息给网关
        function sendMsgToOpenGWapi(appIDTemp){
            $timeout(sendMsgToOpenGW(appIDTemp,0),0);
        }

        // 发送消息给网关，刷新网关，失败重试3次
        function sendMsgToOpenGW(appid,num)
        {
            if (num == 3){
                return;
            }

            OpenGW.sendAppChangeNotice({"appid":appid}).then(function(data){
                if (data == undefined || data.error || !data){
                    sendMsgToOpenGW(appid,num + 1);
                }
            }).catch(function(){
                sendMsgToOpenGW(appid,num + 1);
            });
        }

        return {
            opearteShaService: opearteShaService,
            sendMsgToOpenGWapi:sendMsgToOpenGWapi
        };
    }]);
});

